<div class="ctn-left ctn-wrap ctn-sep">

    <!-- SEGMENT -->
    <ng-container *ngFor="let item of segment; let i = index">
        <div class="item">
            <strong *ngIf="item.begin && !item.begin.min &&!item.begin.value"
                    class="label critBegin">{{ item.begin | dateMoment:dateFormat.momentMedium }}</strong>
            <strong *ngIf="item.begin.value && !item.begin.min"
                    class="label critBegin">{{ item.begin.value | dateMoment:dateFormat.momentMedium }}</strong>
            <ng-container><span *ngIf="item.begin.between" class="label no-margin">{{wording.departure}}</span>
                <strong [innerHTML]="(item.begin | dateTimeRange)" *ngIf="item.begin && item.begin.min"
                        class="label critBeginMin"></strong>
                <strong *ngIf="item.begin.between?.min?.time && !item.begin.between?.max?.time"
                        class="label critBeginMin">
                    {{wording.after}} {{item.begin.between.min.time | timeMoment:dateFormat.momentTime}}
                </strong>
                <strong *ngIf="item.begin.between?.max?.time && !item.begin.between?.min?.time"
                        class="label critBeginMin">
                    {{wording.before}} {{item.begin.between.max.time | timeMoment:dateFormat.momentTime}}
                </strong>
                <strong *ngIf="item.begin.between?.max?.time && item.begin.between?.min?.time"
                        class="label critBeginMin">
                    {{wording.from}} {{item.begin.between.min.time | timeMoment:dateFormat.momentTime}} {{wording.at}} {{item.begin.between.max.time | timeMoment:dateFormat.momentTime}}
                </strong>
            </ng-container>

            <ng-container *ngIf="item.from">
                <strong *ngIf="item.from.airport"
                        class="critFromTo">{{ item.from.airport.iata }} {{labels.onlyAirport}}</strong>
                <strong *ngIf="!item.from.airport" class="critFromTo">{{ item.from }}</strong>
            </ng-container>
            <strong *ngIf="item.from && item.to">
                <fa-icon [icon]="iconArrowRight"></fa-icon>
            </strong>
            <ng-container *ngIf="item.to">
                <strong *ngIf="!item.to.airport" class="critFromTo">{{ item.to }}</strong>
                <strong *ngIf="item.to.airport"
                        class="critFromTo">{{ item.to.airport.iata }} {{labels.onlyAirport}}</strong>
            </ng-container>
            <strong *ngIf="item.end?.xMoment" class="label no-margin"></strong>
            <span *ngIf="item.end?.xMoment">{{wording.arrivalAt}}</span>
            <strong *ngIf="item.end?.xMoment" class="label no-margin">{{wording.nextDay}}</strong>

            <ng-container *ngIf="item.end"><span *ngIf="!item.end.xMoment"
                                                 class="label no-margin">{{wording.arrival}}</span>
                <strong *ngIf="item.end.between?.min?.time && !item.end.between?.max?.time" class="label">
                    {{wording.after}} {{item.end.between.min.time | timeMoment:dateFormat.momentTime}}
                </strong>
                <strong *ngIf="item.end.between?.max?.time && !item.end.between?.min?.time" class="label">
                    {{wording.before}} {{item.end.between.max.time | timeMoment:dateFormat.momentTime}}
                </strong>
                <strong *ngIf="item.end.between?.max?.time && item.end.between?.min?.time" class="label">
                    {{wording.from}} {{item.end.between.min.time | timeMoment:dateFormat.momentTime}} {{wording.at}}
                    {{item.end.between.max.time | timeMoment:dateFormat.momentTime}}
                </strong>
            </ng-container>

            <ng-container *ngIf="item.viaArray">
                <div *ngFor="let via of item.viaArray">
                <span *ngIf="via.duration?.max && via.duration?.xUnit" class="label">
                    <span class="label">{{wording.stopoverTime}}</span>
                    <strong class="label no-margin">{{via.duration.max | duration:via.duration.xUnit}}</strong>
                </span>
                </div>
            </ng-container>

            <div *ngIf="maxViasAndCabinArray[i].maxVias">
                <span class="label">{{ labels.maxVias }}</span>
                <strong class="label no-margin">{{ maxViasAndCabinArray[i].maxViasToDisplay }}</strong>
            </div>

            <div *ngIf="maxViasAndCabinArray[i].cabin">
                <span class="label">{{ labels.cabin }}</span>
                <strong class="label no-margin">{{ maxViasAndCabinArray[i].cabinToDisplay }}</strong>
            </div>

        </div>
    </ng-container>

    <!-- TRAVELLERS -->
    <div *ngIf="quantity" class="item ctn-left ctn-bottom">
        <div class="label hide-l-mb label-traveller">{{wording.travellers}}</div>
        <div class="col-to-row-l-mb">
            <span *ngIf="quantity.adult">
                <strong>{{quantity.adult}}</strong><span class="label">{{wording.adt}}</span>
            </span>
            <span *ngIf="quantity.child">
                <strong>{{quantity.child}}</strong><span class="label">{{wording.chd}}</span>
            </span>
            <span *ngIf="quantity.infant">
                <strong>{{quantity.infant}}</strong><span class="label">{{wording.inf}}</span>
            </span>
        </div>
    </div>

    <!-- PRICE -->
    <div *ngIf="price && (price.value || price?.plusOrMinus?.percentage)" class="item">
        <span *ngIf="price.value">
            <span class="label label-fix-width">{{wording.priceForAdt}} </span>
            <strong [innerHTML]="(price.value | price:'EUR')"></strong>
        </span>
        <span *ngIf="price && price.plusOrMinus && price.plusOrMinus.percentage">
            <span class="label">{{wording.moreAndLess}}</span>
            <strong>{{ price.plusOrMinus.percentage }} %</strong>
        </span>
    </div>

    <ng-container *permissionIf="permission.IQBA_FARETYPE_SHOW">
        <div *ngIf="price && price.fareType" class="item">
            <span class="label label-fix-width">{{wording.typeTariff}} </span>
            <strong>
                <ng-container *ngFor="let priceItem of price.fareType; let i = index">
                    {{ priceItem }}
                    <ng-container *ngIf="i < price.fareType.length-1">,</ng-container>
                </ng-container>
            </strong>
        </div>
    </ng-container>

    <!-- CARRIER -->
    <div *ngIf="carrier" class="item carrier">
        <span class="label label-carrier">{{wording.companies}}</span>

        <span *ngIf="carrier && carrier.preferred && carrier.preferred.length" class="item-carrier hoverPopInfo">
            <span class="label rm-marge-right"><fa-icon [icon]="iconStar"></fa-icon></span>
            <strong>
                <ng-container *ngFor="let carrierItem of carrier.preferred; let i = index">
                    {{ carrierItem }}
                    <ng-container *ngIf="i < carrier.preferred.length-1">, </ng-container>
                </ng-container>
            </strong>
            <div class="popInfoSmall">
                {{wording.favoriteCompanies}}
            </div>
        </span>


        <span *ngIf="carrier && carrier.include && carrier.include.length" class="item-carrier hoverPopInfo">
            <span class="label rm-marge-right"><fa-icon [icon]="iconCheck"></fa-icon></span>
            <strong>
                <ng-container *ngFor="let carrierItem of carrier.include; let i = index">
                    {{ carrierItem }}
                    <ng-container *ngIf="i < carrier.include.length-1">, </ng-container>
                </ng-container>
            </strong>
            <div class="popInfoSmall">
                {{wording.incluedCompanies}}
            </div>
        </span>
        <span *ngIf="carrier && carrier.exclude && carrier.exclude.length" class="item-carrier hoverPopInfo">
            <span class="label rm-marge-right"><fa-icon [icon]="iconBan"></fa-icon></span>
            <strong>
                <ng-container *ngFor="let carrierItem of carrier.exclude; let i = index">
                    {{ carrierItem }}
                    <ng-container *ngIf="i < carrier.exclude.length-1">, </ng-container>
                </ng-container>
            </strong>
            <div class="popInfoSmall">
                {{wording.excludedCompanies}}
            </div>
        </span>
    </div>

    <!-- KEYWORD -->
    <div *ngIf="keyword" class="item">
        <span class="label label-fix-width">{{wording.includedServices}} </span>
        <ng-container *ngFor="let keywordItem of keyword; let i = index">
            <strong class="hoverPopInfo">
                <fa-icon [icon]="keywordDisplay[keywordItem].iconDefinition"></fa-icon>
                <div class="popInfoSmall">
                    {{keywordDisplay[keywordItem].label}}
                </div>
            </strong>
        </ng-container>
    </div>

    <!-- FLEX -->
    <div *ngIf="flexibility && flexibility.begin.plusOrMinus !== 0" class="item">
        <span class="label">+/-</span><!--
        --><strong>{{flexibility.begin.plusOrMinus}}
        <span class="label" *ngIf="flexibility.begin.plusOrMinus === 1">{{wording.day}}</span><!--
            --><span class="label" *ngIf="flexibility.begin.plusOrMinus > 1">{{wording.days}}</span>
    </strong>
    </div>

    <ng-container *permissionIf="permission.IQBA_HOSTCODE_SHOW">
        <div *ngIf="host" class="item">
        <span class="label label-fix-width" [ngPlural]="host.length">
            <ng-template ngPluralCase="=1">{{wording.source}}</ng-template>
            <ng-template ngPluralCase="other">{{wording.sources}}</ng-template>
        </span>
            <strong>
                <ng-container *ngFor="let hostName of host; let i = index">
                    {{ hostName | hostAlias | async }}
                    <ng-container *ngIf="i < host.length-1">,</ng-container>
                </ng-container>
            </strong>
        </div>
    </ng-container>

    <div *ngIf="locator" class="item">
        <span class="label">{{ labels.locator }}</span>
        <strong>{{ locator }}</strong>
    </div>

    <div *ngIf="fullServiceCarriersOnly" class="item">
        <strong>{{ labels.fullServiceCarriersOnly }}</strong>
    </div>

</div>
